import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'qs'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'

const URL_BASE = ''
//const suffix = 'index.json'
const suffix = ''
const SITES = [
  {path:'/', cat:2},
  {path:'/nanao/', cat:11},
  {path:'/chiba/', cat:11},
  {path:'/hachioji/', cat:11},
  {path:'/katase-gakuen/', cat:24},
  {path:'/yachimata-gakuen/', cat:11},
  {path:'/katsuyama-gakuen/', cat:24},
  {path:'/funakata-gakuen/', cat:24},
  {path:'/koyama-gakuen/', cat:11},
  {path:'/shakujii-gakuen/', cat:31},
  {path:'/kibounosato/', cat:11},
  {path:'/higashimurayama/', cat:13},
  {path:'/hino/', cat:24}
]

const ver = '1'
// const ver = '2'

Vue.use(Vuex);

export default new Vuex.Store({
 state: {
    items: [],
    perPage: 5,
    currentPage: 1,
    savedCurrentPage: 1,
    pref: [],
    facility: [],
    jobType: [],
    // employingType: ['非常勤・臨時職員']
    //employingType: ['契約職員']
    employingType: ['正規職員']
 },
 mutations: {
  clearAll(state) {
    state.items = [];
    state.currentPage = 1;
  },
  saveCondition(state) {
    localStorage.setItem('condition_' + ver, JSON.stringify(state))
  },
  loadCondition(state) {
    //console.log(localStorage.getItem('condition'))
    if (localStorage.getItem('condition_' + ver)) {
      const storedState = JSON.parse(localStorage.getItem('condition_' + ver))
      state.pref = storedState.pref;
      state.facility = storedState.facility;
      state.jobType = storedState.jobType;
      state.savedCurrentPage = storedState.currentPage;
    }
  },
  mutateDataSet(state, payload) {
    payload.forEach(newItem => {
      state.items.push(newItem);
    });
    state.items.sort(function(a,b){
    //  console.log([a,b]);
      if (a.data.status.indexOf('正規') !== -1 && b.data.status.indexOf('正規') === -1) {
        return -1;
      }
      if (a.data.status.indexOf('正規') === -1 && b.data.status.indexOf('正規') !== -1) {
        return 1;
      }
      if (a.date < b.date) {
        return 1;
      } else if(a.date > b.date) {
        return -1;
      }
      return 0;
    });
    if ( state.savedCurrentPage && state.savedCurrentPage <= Math.ceil(state.items.length / state.perPage)  ){
    //  console.log([state.savedCurrentPage, Math.ceil(state.items.length / state.perPage)]);
      this.commit('setCurrentPage',state.savedCurrentPage)
    }
  },
  setCurrentPage (state, value) {
    state.currentPage = value
  },
  setSavedCurrentPage (state, value) {
    state.savedCurrentPage = value
  },
  togglePref (state, payload) {
    //console.log(payload);
    if (payload.checked) {
      state.pref.push(payload.value)
    } else {
      state.pref.forEach((item, index) => {
        if(item === payload.value) {
          state.pref.splice(index, 1)
        }
      });
    }
  },
  toggleFacility (state, payload) {
    //console.log(payload);
    if (payload.checked) {
      state.facility.push(payload.value)
    } else {
      state.facility.forEach((item, index) => {
        if(item === payload.value) {
          state.facility.splice(index, 1)
        }
      });
    }
  },
  toggleJobType (state, payload) {
    //console.log(payload);
    if (payload.checked) {
      state.jobType.push(payload.value)
    } else {
      state.jobType.forEach((item, index) => {
        if(item === payload.value) {
          state.jobType.splice(index, 1)
        }
      });
    }
  }
 },
 actions: {
  commitDataSet(store) {
    store.commit('clearAll');
    let params = {};
    let type_params;
    let i = 0;
    let meta_query_params = {
      'relation': 'AND'
    };
      
    //都道府県の取り扱い
    if ( store.state.pref.length ){
      if ( store.state.pref.length > 1 ){
        type_params = {'relation': 'OR'};
        store.state.pref.forEach((v, index) => {
          type_params[index] = {'key':'pref', 'value': v, 'compare': 'like'};
        })
      }else{
        store.state.pref.forEach((v) => {
          type_params = {'key': 'pref', 'value': v, 'compare': 'like'};
        })
      }
      meta_query_params[i] = type_params;
      i++;
    }
    //施設名の取り扱い
    if (store.state.facility.length){
      if (store.state.facility.length > 1){
        type_params = {'relation': 'OR'};
        store.state.facility.forEach((v, index) => {
          type_params[index] = {'key':'facility', 'value': v, 'compare': 'like'};
        })
      }else{
        store.state.facility.forEach((v) => {
          type_params = {'key': 'facility', 'value': v, 'compare': 'like'};
        })
      }
      meta_query_params[i] = type_params;
      i++;
    }
    
    //職種の取り扱い
    if (store.state.jobType.length){
      if (store.state.jobType.length > 1 ){
        type_params = {'relation': 'OR'};
        store.state.jobType.forEach((v, index) => {
          type_params[index] = {'key':'job_type', 'value': v, 'compare': 'like'};
        })
      }else{
        store.state.jobType.forEach((v) => {
          type_params = {'key':'job_type', 'value': v, 'compare': 'like'};
        })
      }
      meta_query_params[i] = type_params;
      i++;
    }
    
    
    //雇用形態の取り扱い
    if (store.state.employingType.length){
      if (store.state.employingType.length > 1 ){
        type_params = {'relation': 'OR'};
        store.state.employingType.forEach((v, index) => {
          type_params[index] = {'key':'employing_type', 'value': v, 'compare': '='};
        })
      }else{
        store.state.employingType.forEach((v) => {
          type_params = {'key':'employing_type', 'value': v, 'compare': '='};
        })
      }
      meta_query_params[i] = type_params;
      i++;
    }
    
    
    
    SITES.forEach(site => {
      //console.log(site);
      params = {
        'post_type': 'post',
        'cat': site.cat,
        'posts_per_page': 100,
        'meta_query': meta_query_params
      };
      return axios.get(URL_BASE + site.path + 'wp-json/wp_query/args/' + suffix + '?_embed',{
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, {arrayFormat: 'brackets'})
        }
      })
      .then(response => {
       store.commit('mutateDataSet', response.data)
      })
      .catch((reason) => {
       console.log(reason.message)
      })
    })
  }
 },
 getters: {
  getStateDataSet: (state) => state.dataSet
 }
})